export const CHAT_FILTERS_NUDGE_STEP_KEY = "CHAT_FILTERS_NUDGE";

export const CHAT_FILTERS_NUDGE_TEXT =
  "Filter chats by unread, action pending, entity, or year.";
